import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import InterfaceFinishedModel from '../models/InterfaceFinishedModel';
import Globals from '../../../utils/Globals';

const InterfacerunView = Backbone.View.extend({
    model: null,
    interfaceView: null,
    initialize() {
        this.model = new InterfaceFinishedModel();
        this.poll();
        this.render();
    },
    render() {
    },
    poll() {
        const view = this;
        const showForAll = Globals.serverConfig.datainterface_isRun_showForAll;
        this.model.pollStatus(model => {
            if (!_.isUndefined(model.get('schema')) && (showForAll || model.get('schema').id === Globals.schemaUserModel.id)) {
                if (view.interfaceView !== null) {
                    console.log('The Model from Poll:', model);
                    const { interfaceView } = view;
                    const category = interfaceView.collection.find(fm => fm.get('name') === model.get('category_id'));
                    if (category !== null) {
                        const minterface = category.view.collection.get(model.get('interface_id'));
                        if (minterface !== null) {
                            if (!_.isUndefined(minterface.view.collection)) {
                                const oldRs = minterface.view.collection.get(model.id);
                                if (!_.isUndefined(oldRs)) {
                                    oldRs.set(model.attributes);
                                } else {
                                    minterface.view.collection.add(model, { at: 0 });
                                }
                            }
                        }
                    }
                }
            }
        });
    },
});
export default InterfacerunView;
